<template>
  <v-flex>
    <v-layout align-center class="dialog-search">
      <v-flex wrap class="filter-container">
        <div class="filter-by-type">
          <span class="filter-by-title">Filter by</span>
          <ul class="circle-list">
            <li
              v-for="(item, index) in sortTypes"
              :key="index"
              :class="{'circle_big': activeSortList.includes(item.type) }"
              class="circle"
              :style="{background: sortTypes[index].color}"
            />
          </ul>
          <div
            class="filter-popup"
          >
            <ul>
              <li
                v-for="(item, index) in sortTypes"
                :key="index"
                @click="setFilter(item.type)"
              >
                <span
                  class="circle"
                  :class="{ 'active': activeSortList.includes(item.type) }"
                  :style="{ background: sortTypes[index].color, borderColor: sortTypes[index].color }"
                />
                <span for="checkbox">{{ item.text }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <span class="date-filter">Date</span>
          <v-icon
            :class="{'sortArrow': true, 'up': !dateSort}"
            @click="$emit('sort-by-date')"
          >
            {{ $vuetify.icons.expand }}
          </v-icon>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    dateSort: {
      type: Boolean,
      default: false
    },
    activeSortList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      clickedCircle: null,
      sortTypesBase: [
        {
          color: '#B02BC7',
          type: 'offer_message',
          text: 'Make Offer'
        },
        {
          color: '#00acc1',
          type: 'home_message',
          text: 'Question About Home'
        },
        {
          color: '#58a76c',
          type: 'route_schedule_message',
          text: 'Schedule'
        },
        {
          color: '#909090',
          type: 'common_message',
          text: 'General'
        }
      ],
      sortTypesClient: [{
        color: '#289A95',
        type: 'provide_feedback_message',
        text: 'Feedback'
      }],
      show: false,
      checked: false,
      checkedBox: null
    }
  },
  computed: {
    ...mapState('common', ['profileStatus']),
    sortTypes() {
      if (this.profileStatus === 'client') {
        return [...this.sortTypesBase, ...this.sortTypesClient]
      }
      return this.sortTypesBase
    }
  },
  methods: {
    setFilter(type) {
      let updatedList = [...this.activeSortList]
      if (this.activeSortList.includes(type)) {
        updatedList = this.activeSortList.filter(item => item !== type)
      } else {
        updatedList.push(type)
      }
      this.$emit('sort-by-types', updatedList)
    }
  }

}
</script>

<style lang="sass">
.filter-by-type
  padding: 25px 0 20px
.filter-by-type:hover
  .filter-popup
    display: block

.filter-popup
  display: none
  border: 1px solid #ececec
  box-shadow: 1px 0px 9px rgba(0, 0, 0, 0.1)
  position: absolute
  left: 5%
  top: 60px
  padding: 10px
  width: 90%
  z-index: 2
  background: #fff
  &:after, &:before
    bottom: 100%
    left: 40%
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
  &:after
      border-color: rgba(238, 238, 238, 0)
      border-bottom-color: #fff
      border-width: 10px
      margin-left: -10px
  &:before
      border-color: rgba(204, 204, 204, 0)
      border-bottom-color: #ececec
      border-width: 11px
      margin-left: -11px
  li
    margin-bottom: 5px !important
    text-align: left
    &:last-child
      margin-bottom: 0px !important
  span
    font-size: 14px
    margin-left: 5px
    vertical-align: middle
  .circle
    width: 15px
    height: 15px
    border: 1px solid #fff
    &:not(.active)
      background: #fff !important
.dialog-search
  border-bottom: 1px solid #ececec
  background: #fff
  width: 100%
  height: 70px
  font-size: 12px
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07)
.filter-container
  position: relative
  display: flex
  align-items: baseline
  justify-content: space-between
  flex-direction: row
  flex-wrap: wrap
.circle-list
  display: inline-block
  margin-left: 12px
.filter-by-title
  padding-left: 2rem
  margin-right: 10px
.filter-by-title, .date-filter, .v-icon
  color: $hwayzMediumGray
.date-filter
  padding-left: 1rem
.sortArrow.up
  transform: rotate(180deg)
.circle
  cursor: pointer
  display: inline-block
  border-radius: 50%
  width: 8px
  height: 8px
  margin-right: 7px !important
  background: $hwayzMediumGray
  vertical-align: middle
  &_purple
    background: #B02BC7
  &_green
    background: $hwayzGreen
  &_red
    background: $hwayzRed
  &_blue
    background: $hwayzBlue
  &_big
    width: 12px
    height: 12px
</style>

<style lang="sass" scoped>
.v-icon
  vertical-align: middle !important
  padding: 0 1rem
</style>
